export default __webpack_public_path__ + "static/media/327.25a4a287.jpg";